import { render, staticRenderFns } from "./cardNotasTrabajoSocial.vue?vue&type=template&id=2318f20d"
import script from "./cardNotasTrabajoSocial.vue?vue&type=script&lang=js"
export * from "./cardNotasTrabajoSocial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports